// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2Uu8b","checkboxCol":"Table_checkboxCol__3jnFU","emailCol":"Table_emailCol__2mK9N","actionCol":"Table_actionCol__2ywt7"};